import "./styles.scss"
import "./carousel.js"
import "../blocks/gallery-searchable/scripts.js"
import "../components/site-search/scripts.js"

const startHeader = () => {
  const BREAKPOINT = 1024
  const header = document.querySelector('header')
  const headerMain = document.querySelector('.header-main')
  const menuToggle = document.querySelector('#menu-toggle')
  const primaryNav = document.querySelector('nav.primary')
  const menuItems = document.querySelectorAll('.menu-item-has-children')
  const allMenuItems = document.querySelectorAll('nav.primary > .menu > .menu-item')

  let isDesktop = window.innerWidth >= BREAKPOINT
  let desktopListenersActive = false
  let mobileListenersActive = false

  // scroll tracking
  let lastScrollY = window.scrollY
  let scrollUpDistance = 0
  let hasScrolledOnce = false

  // remove all open classes
  const removeAllOpen = () => {
    menuToggle?.classList.remove('open')
    primaryNav?.classList.remove('open')
    menuItems.forEach(item => item.classList.remove('open'))
  }

  // desktop listeners
  const addDesktopListeners = () => {
    if (desktopListenersActive) return

    menuItems.forEach(item => {
      item.addEventListener('mouseenter', handleDesktopMouseEnter)

      // add mouseleave listener to the submenu
      const submenu = item.querySelector('.sub-menu')
      if (submenu) {
        submenu.addEventListener('mouseleave', handleDesktopSubmenuMouseLeave)
      }
    })

    // add listener to all menu items
    allMenuItems.forEach(item => {
      if (!item.classList.contains('menu-item-has-children')) {
        item.addEventListener('mouseenter', handleRegularMenuItemHover)
      }
    })

    // close submenus when leaving header-main
    headerMain?.addEventListener('mouseleave', handleHeaderMainMouseLeave)

    desktopListenersActive = true
  }

  const removeDesktopListeners = () => {
    if (!desktopListenersActive) return

    menuItems.forEach(item => {
      item.removeEventListener('mouseenter', handleDesktopMouseEnter)

      const submenu = item.querySelector('.sub-menu')
      if (submenu) {
        submenu.removeEventListener('mouseleave', handleDesktopSubmenuMouseLeave)
      }
    })

    allMenuItems.forEach(item => {
      if (!item.classList.contains('menu-item-has-children')) {
        item.removeEventListener('mouseenter', handleRegularMenuItemHover)
      }
    })

    headerMain?.removeEventListener('mouseleave', handleHeaderMainMouseLeave)

    desktopListenersActive = false
  }

  const handleDesktopMouseEnter = (e) => {
    const item = e.currentTarget

    // close any other open menu items
    menuItems.forEach(otherItem => {
      if (otherItem !== item) {
        otherItem.classList.remove('open')
      }
    })

    // open this one
    item.classList.add('open')
  }

  const handleRegularMenuItemHover = () => {
    // close all open submenus when hovering a regular menu item
    menuItems.forEach(item => {
      item.classList.remove('open')
    })
  }

  const handleDesktopSubmenuMouseLeave = (e) => {
    // Only close if mouse is not moving to the parent menu item
    const parentItem = e.currentTarget.closest('.menu-item-has-children')
    if (parentItem && e.relatedTarget && !parentItem.contains(e.relatedTarget)) {
      parentItem.classList.remove('open')
    }
  }

  const handleHeaderMainMouseLeave = () => {
    // close all open submenus when mouse leaves header-main
    menuItems.forEach(item => {
      item.classList.remove('open')
    })
  }

  // mobile listeners
  const addMobileListeners = () => {
    if (mobileListenersActive) return

    menuToggle?.addEventListener('click', handleMenuToggle)
    document.addEventListener('click', handleOutsideClick)
    menuItems.forEach(item => {
      item.addEventListener('click', handleMobileMenuItemClick)
    })

    // add click handlers for back-to-parent buttons
    const backButtons = document.querySelectorAll('.back-to-parent')
    backButtons.forEach(button => {
      button.addEventListener('click', handleBackToParent)
    })

    mobileListenersActive = true
  }

  const removeMobileListeners = () => {
    if (!mobileListenersActive) return

    menuToggle?.removeEventListener('click', handleMenuToggle)
    document.removeEventListener('click', handleOutsideClick)
    menuItems.forEach(item => {
      item.removeEventListener('click', handleMobileMenuItemClick)
    })

    // remove click handlers for back-to-parent buttons
    const backButtons = document.querySelectorAll('.back-to-parent')
    backButtons.forEach(button => {
      button.removeEventListener('click', handleBackToParent)
    })

    mobileListenersActive = false
  }

  const handleMenuToggle = (e) => {
    e.stopPropagation()
    menuToggle.classList.toggle('open')
    primaryNav.classList.toggle('open')

    const isOpen = menuToggle.classList.contains('open')

    // toggle locked class on body
    document.body.classList.toggle('locked', isOpen)

    if (isOpen) {
      // remove minimized when opening menu
      header.classList.remove('minimized')

      // add first-scroll-complete on first mobile menu open
      if (!hasScrolledOnce) {
        document.body.classList.add('first-scroll-complete')
        hasScrolledOnce = true
      }
    } else {
      // if closing, remove open from all menu items
      menuItems.forEach(item => item.classList.remove('open'))
    }
  }

  const handleOutsideClick = (e) => {
    if (!header.contains(e.target) && menuToggle.classList.contains('open')) {
      menuToggle.classList.remove('open')
      primaryNav.classList.remove('open')
      document.body.classList.remove('locked')
      menuItems.forEach(item => item.classList.remove('open'))
    }
  }

  const handleMobileMenuItemClick = (e) => {
    const item = e.currentTarget

    // only toggle if clicking on the parent item itself, not children
    if (e.target.closest('.sub-menu')) return

    e.preventDefault()
    e.stopPropagation()
    item.classList.toggle('open')
  }

  const handleBackToParent = (e) => {
    e.preventDefault()
    e.stopPropagation()

    // find the parent .menu-item and remove .open
    const parentMenuItem = e.currentTarget.closest('.menu-item')
    if (parentMenuItem) {
      parentMenuItem.classList.remove('open')
    }
  }

  // prevent default on # links
  const preventHashLinks = (e) => {
    if (e.target.tagName === 'A' && e.target.getAttribute('href') === '#') {
      e.preventDefault()
    }
  }

  // add listener for all menu links
  primaryNav?.addEventListener('click', preventHashLinks)

  // handle resize
  const handleResize = () => {
    const wasDesktop = isDesktop
    isDesktop = window.innerWidth >= BREAKPOINT

    // if breakpoint crossed, remove all open classes and switch listeners
    if (wasDesktop !== isDesktop) {
      removeAllOpen()

      if (isDesktop) {
        removeMobileListeners()
        addDesktopListeners()
      } else {
        removeDesktopListeners()
        addMobileListeners()
      }
    }
  }

  // init based on current screen size
  if (isDesktop) {
    addDesktopListeners()
  } else {
    addMobileListeners()
  }

  // handle scroll
  const handleScroll = () => {
    const currentScrollY = window.scrollY

    if (currentScrollY > lastScrollY) {
      // scrolling down
      header.classList.add('minimized')
      scrollUpDistance = 0

      // add first-scroll-complete to body on first scroll
      if (!hasScrolledOnce) {
        document.body.classList.add('first-scroll-complete')
        hasScrolledOnce = true
      }
    } else {
      // scrolling up
      scrollUpDistance += lastScrollY - currentScrollY

      if (scrollUpDistance >= 100) {
        header.classList.remove('minimized')
        scrollUpDistance = 0
      }
    }

    lastScrollY = currentScrollY
  }

  // listen for resize
  window.addEventListener('resize', handleResize)

  // listen for scroll
  window.addEventListener('scroll', handleScroll)
}

const startModals = () => {
  const dialogs = document.querySelectorAll('dialog')

  dialogs.forEach(dialog => {
    // enable click on backdrop to close for all (normal) modals
    dialog.addEventListener('click', e => {
      const d = dialog.getBoundingClientRect()
      if (
        e.clientX < d.left ||
        e.clientX > d.right ||
        e.clientY < d.top ||
        e.clientY > d.bottom
      )
        dialog.close()
    }, true)
  })
}

const startScrollWatcher = () => {
	window.addEventListener("scroll", scrollFunc);
	document.addEventListener("DOMContentLoaded", scrollFunc);
	function scrollFunc() {
		var elements = [...document.querySelectorAll(".animate:not(.active)"),];
		for (var i = 0; i < elements.length; i++) {
			var windowHeight = window.innerHeight;
			var elementTop = elements[i].getBoundingClientRect().top;
			var elementVisible = 100;
			if (
				elementTop < windowHeight - elementVisible ||
				elements[i].classList.contains("initiate")
			) {
        // if (elements[i].classList.contains('animated-text') && !elements[i].classList.contains('active') && !getAnimationStatus(elements[i])) {
        //   animateCharacters(elements[i]);
        // }
				elements[i].classList.add("active");
			}
		}
	}
}

const startTextType = () => {
  const headings = document.querySelectorAll('.hero:not(.is-style-legal) .heading, .hero-honour .heading')

  headings.forEach(heading => {
    const show = document.createElement('span')
    const hide = document.createElement('span')
    show.classList.add('show')
    hide.classList.add('hide')

    const text = heading.textContent
    heading.textContent = ''
    heading.appendChild(show)
    heading.appendChild(hide)
    hide.textContent = text

    textType(show, hide)
  })
}

const textType = (show, hide) => {
  if (hide.textContent.length < 1) return

  show.textContent = show.textContent + hide.textContent.charAt(0)
  hide.textContent = hide.textContent.slice(1)

  setTimeout(() => textType(show, hide), 50)
}

// const textType = (element, text, i = 0) => {
//   if (i >= text.length) return
//
//   element.textContent = element.textContent + text[i]
//
//   setTimeout(() => textType(element, text, i + 1), 75)
// }

// ANIMATED TEXT FUNCTIONS --------------------------
// const startAnimatedText = () => {
//   const headings = document.querySelectorAll(".animated-text");
//   headings.forEach(heading => {
//       const text = heading.textContent;
//       heading.textContent = '';
//       heading.classList.remove('active');
//       heading.setAttribute('data-animating', 'false');
//
//       const words = text.split(' ');
//
//       words.forEach((word, index) => {
//           const wordSpan = document.createElement('span');
//           wordSpan.className = 'word';
//           wordSpan.style.display = 'inline-block';
//
//           word.split('').forEach(char => {
//               const charSpan = document.createElement('span');
//               charSpan.textContent = char;
//               charSpan.style.opacity = 0;
//               wordSpan.appendChild(charSpan);
//           });
//           heading.appendChild(wordSpan);
//
//           if (index < words.length - 1) {
//               const spaceSpan = document.createElement('span');
//               spaceSpan.textContent = '\u00A0';
//               heading.appendChild(spaceSpan);
//           }
//       });
//   });
// }
// const animateCharacters = (heading) => {
//   const spans = heading.querySelectorAll('span.word span');
//   heading.setAttribute('data-animating', 'true');
//   spans.forEach((span, index) => {
//       setTimeout(() => {
//           span.style.opacity = 1;
//           if (index === spans.length - 1) {
//               heading.setAttribute('data-animating', 'false');
//           }
//       }, index * 60);
//   });
// }
// const getAnimationStatus = (heading) => {
//   return heading.getAttribute('data-animating') === 'true';
// }
// END OF ANIMATED TEXT FUNCTIONS -------------------

// EASTER EGG HEHE - REMOVE BEFORE WE GO TO PROD
// const startEasterEgg = () => {

//     const secretCode = ['Control', 's', 'h', 'o', 't'];
//     const soundEffectUrl = '/wp-content/themes/operatic/easter-egg-assets/boom.wav';

//     let keySequence = [];
//     let sequenceTimeout;
//     let isEasterEggActive = false;
//     let audio;

//     function activateEasterEgg() {
//       console.log('Easter Egg Activated! ✨');
//       document.body.classList.add('easter-egg-active');
//       isEasterEggActive = true;
//       audio = new Audio(soundEffectUrl);
//       document.body.appendChild(audio);
//       document.addEventListener('click', playSoundOnClick);
//     }

//     function deactivateEasterEgg() {
//       console.log('Easter Egg Deactivated.');
//       document.body.classList.remove('easter-egg-active');
//       isEasterEggActive = false;
//       document.removeEventListener('click', playSoundOnClick);
//       if (audio) {
//         audio.remove();
//       }
//     }

//     function playSoundOnClick() {
//       if (audio) {
//         audio.currentTime = 0;
//         audio.play();
//       }
//     }

//     document.addEventListener('keydown', function(e) {
//       keySequence.push(e.key);

//       clearTimeout(sequenceTimeout);
//       sequenceTimeout = setTimeout(() => {
//         keySequence = [];
//       }, 1500);

//       if (keySequence.join('').includes(secretCode.join(''))) {
//         console.log('Secret code detected!');
//         keySequence = [];

//         if (isEasterEggActive) {
//           deactivateEasterEgg();
//         } else {
//           activateEasterEgg();
//         }
//       }
//     });
// }

const startTeamGridListeners = () => {
  const teamGrids = document.querySelectorAll('.team-grid')

  if (teamGrids.length > 0) {
    teamGrids.forEach(teamGrid => {
      const openModalButtons = teamGrid.querySelectorAll('.button-secondary');
      const teamGridDialog = teamGrid.querySelector('.team-member-modal');

      openModalButtons.forEach(button => {
        button.addEventListener('click', e => {
          e.preventDefault();
          const modalID = button.getAttribute('data-modal-id');
          teamGridDialog.showModal()
          teamGridDialog.querySelector(`#modal-${modalID}`).classList.add('active');
          // Lock page scroll
          document.body.style.overflow = 'hidden';
        })
      })

      const closeModal = (e) => {
        teamGridDialog.querySelector('.active').classList.remove('active');
        teamGridDialog.close();
        // Unlock page scroll
        document.body.style.overflow = 'auto';
      }

      const closeButton = teamGridDialog.querySelector('.close-modal');
      closeButton.addEventListener('click', closeModal);

      // Close modal if its open, and someone hits 'esc'
      window.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
          if (teamGridDialog.open) {
            closeModal();
          }
        }
      })
    })
  }
}

const setupCopyLinks = () => {
  document.querySelectorAll('.copy-link').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault()
      navigator.clipboard.writeText(window.location.href)
      link.classList.add('clicked')
      setTimeout(() => {
        link.classList.remove('clicked')
      }, 500)
    })
  });
}

const startOverviewAccordion = () => {
  const button = document.querySelector('.feature-overview button')

  if (button) {
    button.addEventListener('click', () => {
      button.parentElement.classList.toggle('open')
    })
  }
}

const startScrollRevealer = () => {
  const steps = document.querySelectorAll('.scroll-revealer-container .step')

  if (!steps.length) return

  const BREAKPOINT = 767
  const headingContainer = document.querySelector('.scroll-revealer-container .steps-container > .heading-container')
  const heading = headingContainer?.querySelector('.heading')
  const image = document.querySelector('.scroll-revealer-container .featured-image')
  const container = document.querySelector('.scroll-revealer-container')

  const applyHeadingMargin = () => {
    if (!headingContainer || !heading) return

    if (window.innerWidth < BREAKPOINT) {
      const headingHeight = heading.getBoundingClientRect().height
      const halfHeight = headingHeight / 2
      const marginTop = -halfHeight - 30
      headingContainer.style.marginTop = `${marginTop}px`
    } else {
      headingContainer.style.marginTop = ''
    }
  }

  const checkActiveStep = () => {
    const triggerPoint = window.innerHeight * 0.5
    let activeStep = null

    steps.forEach(step => {
      const rect = step.getBoundingClientRect()
      const stepTop = rect.top
      const stepBottom = rect.bottom

      // Check if the trigger point (60% from top) is within this step
      if (stepTop <= triggerPoint && stepBottom >= triggerPoint) {
        activeStep = step
      }
    })

    // Update active classes on steps
    steps.forEach(step => {
      if (step === activeStep) {
        step.classList.add('active')
      } else {
        step.classList.remove('active')
      }
    })

    // Parallax effect for image
    if (image && container) {
      const containerRect = container.getBoundingClientRect()
      const containerTop = containerRect.top
      const containerHeight = containerRect.height
      const viewportHeight = window.innerHeight

      // Calculate scroll progress through the container (0 to 1)
      // When container top is at viewport bottom, progress = 0
      // When container bottom is at viewport top, progress = 1
      const scrollProgress = Math.max(0, Math.min(1, (viewportHeight - containerTop) / (containerHeight + viewportHeight)))

      // Apply parallax transform diagonally (reversed - bottom-right to top-left)
      // Move from +2.5% to -2.5% on both X and Y (total 5% movement since image is 110% size)
      const parallaxAmount = 2.5 - (scrollProgress * 5)

      image.style.transform = `translate(${parallaxAmount}%, ${parallaxAmount}%)`
    }
  }

  const handleResize = () => {
    applyHeadingMargin()
    checkActiveStep()
  }

  // Check on scroll
  window.addEventListener('scroll', checkActiveStep)
  // Check on resize
  window.addEventListener('resize', handleResize)

  // Initial setup - wait for fonts to load
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      applyHeadingMargin()
      checkActiveStep()
    })
  } else {
    // Fallback for browsers without font loading API
    setTimeout(() => {
      applyHeadingMargin()
      checkActiveStep()
    }, 100)
  }
}

const startGallery = () => {
  const gallery = document.querySelector('article.gallery')

  if (gallery) {
    const images = gallery.querySelectorAll('img')
    const dialog = gallery.querySelector('dialog')

    images.forEach(image => {
      image.addEventListener('click', e => {
        document.body.style.overflow = 'hidden'

        dialog.querySelector('.content').innerHTML = e.target.outerHTML
        dialog.showModal()
      })
    })

    dialog.addEventListener('close', e => {
      document.body.style.overflow = 'auto'
    })
  }
}

const startMediaBlock = () => {
  const mediaBlock = document.querySelector('article.media')
  if (!mediaBlock) return

  const formatTime = (seconds) => {
    if (isNaN(seconds)) return '0:00'
    const mins = Math.floor(seconds / 60)
    const secs = Math.floor(seconds % 60)
    return `${mins}:${secs.toString().padStart(2, '0')}`
  }

  const tracks = mediaBlock.querySelectorAll('.track')
  const allAudios = []

  tracks.forEach(track => {
    const audio = track.querySelector('audio')
    if (!audio) return

    allAudios.push(audio)

    const playBtn = track.querySelector('.play-btn')
    const rewindBtn = track.querySelector('.rewind-btn')
    const forwardBtn = track.querySelector('.forward-btn')
    const progressContainer = track.querySelector('.progress-container')
    const progressBar = track.querySelector('.progress-bar')
    const currentTimeEl = track.querySelector('.current-time')
    const durationEl = track.querySelector('.duration')
    const iconPlay = track.querySelector('.icon-play')
    const iconPause = track.querySelector('.icon-pause')

    const setPlaying = (playing) => {
      iconPlay.style.display = playing ? 'none' : ''
      iconPause.style.display = playing ? '' : 'none'
    }

    audio.addEventListener('loadedmetadata', () => {
      durationEl.textContent = formatTime(audio.duration)
    })

    audio.addEventListener('timeupdate', () => {
      currentTimeEl.textContent = formatTime(audio.currentTime)
      if (audio.duration) {
        progressBar.style.width = (audio.currentTime / audio.duration * 100) + '%'
      }
    })

    audio.addEventListener('ended', () => {
      setPlaying(false)
    })

    playBtn.addEventListener('click', () => {
      if (audio.paused) {
        // pause all others
        allAudios.forEach(other => {
          if (other !== audio && !other.paused) {
            other.pause()
            const otherTrack = other.closest('.track')
            otherTrack.querySelector('.icon-play').style.display = ''
            otherTrack.querySelector('.icon-pause').style.display = 'none'
          }
        })
        audio.play()
        setPlaying(true)
      } else {
        audio.pause()
        setPlaying(false)
      }
    })

    rewindBtn.addEventListener('click', () => {
      audio.currentTime = Math.max(0, audio.currentTime - 10)
    })

    forwardBtn.addEventListener('click', () => {
      audio.currentTime = Math.min(audio.duration || 0, audio.currentTime + 10)
    })

    progressContainer.addEventListener('click', (e) => {
      const rect = progressContainer.getBoundingClientRect()
      const ratio = (e.clientX - rect.left) / rect.width
      audio.currentTime = ratio * (audio.duration || 0)
    })

    const hoverTime = progressContainer.querySelector('.hover-time')
    progressContainer.addEventListener('mousemove', (e) => {
      const rect = progressContainer.getBoundingClientRect()
      const ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width))
      const time = ratio * (audio.duration || 0)
      hoverTime.textContent = formatTime(time)
      hoverTime.style.left = (ratio * 100) + '%'
    })
  })

  // Video modal
  const dialog = mediaBlock.querySelector('.media-video-modal')
  if (dialog) {
    const iframe = dialog.querySelector('iframe')
    const modalTitle = dialog.querySelector('.modal-title')
    const modalCredit = dialog.querySelector('.modal-credit')

    const openVideo = (track) => {
      iframe.src = `https://player.vimeo.com/video/${track.dataset.vimeoId}&autoplay=1&title=0&byline=0&portrait=0&end_action=nothing`
      modalTitle.textContent = track.dataset.title || ''
      modalCredit.textContent = track.dataset.credit || ''
      dialog.showModal()
      document.body.style.overflow = 'hidden'
    }

    mediaBlock.querySelectorAll('.video-play-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const track = btn.closest('.track')
        if (track.dataset.vimeoId) openVideo(track)
      })
    })

    dialog.addEventListener('close', () => {
      iframe.src = ''
      document.body.style.overflow = 'auto'
    })
  }
}

// startHeader()
// startModals()
// startScrollWatcher()
// INITIALIZERS
startHeader();
// startAnimatedText();
startTextType()
startScrollWatcher();
// startEasterEgg();
startTeamGridListeners()
setupCopyLinks()
startOverviewAccordion()
startScrollRevealer()
startGallery()
startMediaBlock()
